import api, { BodyData } from '../../../utils/api';

export interface SaveGeneralSettingsPayload extends BodyData {
    readonly agencyId: string;
    readonly automaticEnrichment: boolean;
    readonly privacyPolicyUrl: string;
    readonly logoUrl: string;
}

const saveGeneralSettings = async (data: SaveGeneralSettingsPayload): Promise<void> => {
    await api.post(`api/agency/${data.agencyId}/settings/general/save`, data);
}

export default saveGeneralSettings;
